import React from "react";
import { motion } from "framer-motion";
import works1 from "../../assets/images/works1.png";
import works2 from "../../assets/images/works2.png";
import works3 from "../../assets/images/works3.png";
import num1 from "../../assets/images/Number1.png";
import num2 from "../../assets/images/Number2.png";
import num3 from "../../assets/images/Number3.png";
import num4 from "../../assets/images/Number4.png";
import line from "../../assets/images/Line.png";
import { useTranslation } from "react-i18next";

const steps = [
  { num: num1, img: works1, title: "h_s4_c1_title", desc: "h_s4_c1_des" },
  { num: num2, img: works2, title: "h_s4_c2_title", desc: "h_s4_c2_des" },
  { num: num3, img: works3, title: "h_s4_c3_title", desc: "h_s4_c3_des" },
  { num: num4, img: works3, title: "h_s4_c4_title", desc: "h_s4_c4_des" }
];

export default function HowItWorks() {
    const { t, i18n } = useTranslation();
  
  return (
    <div
      id="howItWorks"
      className={`${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"} container top rounded-5`}
      style={{
        height: "100vh",
        overflowY: "scroll",
        scrollSnapType: "y mandatory",
        display: "flex"
      }}
    >
      {/* Fixed Left Column */}
      <div
        className="col-md-3 d-none d-md-flex align-items-start"
        style={{
          position: "sticky",
          top: 0,
          height: "100vh",
          paddingTop: "3rem"
        }}
      >
        <h2
          className="fw-bold"
          style={{
            fontSize: "2.4rem",
          }}
        >
          {t("h_s4_title")}
        </h2>
      </div>

      {/* Scrollable Steps */}
      <div className="flex-grow-1" style={{ flex: 1 }}>
        {steps.map((step, index) => (
          <section
            key={index}
            className="row p-3"
            style={{
              height: "100vh",
              scrollSnapAlign: "start",
              display: "flex",
              alignItems: "center",
              position: "relative"
            }}
          >
            {/* Middle column with text + animated line */}
            <div className="col-md-5" style={{ marginTop: "50px", position: "relative" }}>
              <motion.div
                className="d-flex"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                viewport={{ once: false, amount: 0.6 }}
              >
                <img src={step.num} style={{ width: "73.46px", height: "61.65px", zIndex: 2 }} />
                <div className="ms-4">
                  <h3
                    className="fw-bold mt-2"
                  >
                    {t(step.title)}
                  </h3>
                  <p
                    className="me-4 p-size"
                  >
                    {t(step.desc)}
                  </p>
                </div>
              </motion.div>

              {/* Animated connecting line */}
              {index < steps.length - 1 && (
                <motion.div
                className="d-none d-md-block" // Hides on mobile
                  initial={{ height: 0, opacity: 0 }}
                  whileInView={{ height: "100%", opacity: 1 }}
                  transition={{ duration: 0.8, ease: "easeInOut" }}
                  viewport={{ once: false, amount: 0.6 }}
                  style={{
                    position: "absolute",
                    [i18n.language === 'ar' ? 'right' : 'left']: "45px",
                    top: "50px",
                    width: "4px",
                    background: `url(${line}) center/contain repeat-y`,
                    zIndex: 1
                  }}
                />
              )}

              {/* Mobile image */}
              <div className="d-flex flex-column flex-md-row">
                <img
                  src={step.img}
                  className="img-fluid d-block d-md-none mt-3"
                  style={{  minWidth:"350px", minHeight:"350px" }}
                />
              </div>
            </div>

            {/* Right column images (desktop only) */}
           {/* Right column images (desktop only) */}
<div className="col-md-4 d-none d-md-flex justify-content-center">
  <motion.img
    src={step.img}
    style={{
      width: "350px",
      height: "300px",
      objectFit: "contain",
      opacity: 1,
      transform: "rotate(0deg)"
    }}
    initial={{ opacity: 0, scale: 0.9 }}
    whileInView={{
      opacity: 1,
      scale: 1,
      transition: { duration: 0.6 }
    }}
    viewport={{ once: false, amount: 0.6 }}
  />
</div>

          </section>
        ))}
      </div>
    </div>
  );
}
